module.exports = __webpack_public_path__ + "static/media/shot_1.5e140d5b.mp3";